import { SensorWCActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const SensorWCReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case SensorWCActionType.SensorWC_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default SensorWCReducer
